import config from '../config/apiConfig';

const getHeaders = () => {
    return {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('token')
    };
};

const getUrl = (endpoint) => {
    const base = config.api_url.endsWith('/') ? config.api_url : `${config.api_url}/`;
    return base + endpoint;
};

export const obtenerMesas = async () => {
    const res = await fetch(getUrl('api/v1/mesas'), { headers: getHeaders() });
    return await res.json();
};

export const crearMesa = async (nombre) => {
    const res = await fetch(getUrl('api/v1/mesas'), {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ nombre })
    });
    return await res.json();
};

export const liberarMesa = async (mesaId) => {
    // Ajusta la URL según cómo se llame tu endpoint en Python
    const response = await fetch(config.api_url + `/api/v1/mesas/${mesaId}/liberar`, {
        method: 'POST',
        headers: getHeaders()
    });
    if (!response.ok) throw new Error("Error al liberar mesa");
    return await response.json();
};

export const actualizarMesa = async (id, nombre) => {
    const res = await fetch(getUrl(`api/v1/mesas/${id}`), {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify({ nombre })
    });
    return await res.json();
};

export const eliminarMesa = async (id) => {
    const res = await fetch(getUrl(`api/v1/mesas/${id}`), {
        method: 'DELETE',
        headers: getHeaders()
    });
    return await res.json();
};